import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';
import UpArrowSVG from './svg-nofill/icon-up-arrow.svg';

const UpArrow: React.FC<SvgIconProps> = (svgIconProps: SvgIconProps) => (
    <SvgIcon preserveAspectRatio="xMinYMin meet" {...svgIconProps} component={UpArrowSVG} />
);

export default UpArrow;
